module.exports = __webpack_public_path__ + "img/elephant.cf84d6d.png";